(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pinterest-gallery-tab"] && !Shopify.designMode) return;
  try {
    

(function () {

  const GENERATED_NAV_SELECTOR =
    '.ptg-group-nav[data-ptg-generated="true"]';


  function gallerySections() {

    return Array.from(
      document.querySelectorAll(
        '.ptg-tab-section[data-ptg-group]'
      )
    );

  }


  function findSectionByShopifyId(sectionId) {

    return gallerySections().find(function (section) {

      return (
        section.dataset.ptgSectionId === sectionId
      );

    });

  }


  function getWrapper(section) {

    return (
      section.closest('.shopify-section') ||
      section
    );

  }


  function copyNavigationStyles(source, nav) {

    const computed =
      window.getComputedStyle(source);

    const properties = [
      '--ptg-max-width',
      '--ptg-tabs-bg',
      '--ptg-tab-bg',
      '--ptg-tab-color',
      '--ptg-tab-active-bg',
      '--ptg-tab-active-color',
      '--ptg-tab-radius',
      '--ptg-tab-gap'
    ];

    properties.forEach(function (property) {

      const value =
        computed.getPropertyValue(property);

      if (value) {

        nav.style.setProperty(
          property,
          value
        );

      }

    });

  }


  function pauseSectionMedia(section) {

    section
      .querySelectorAll('video')
      .forEach(function (video) {

        try {

          video.pause();

        } catch (error) {}

      });


    section
      .querySelectorAll(
        'iframe[data-ptg-src]'
      )
      .forEach(function (frame) {

        const originalSource =
          frame.dataset.ptgSrc;

        if (originalSource) {

          frame.src =
            originalSource;

        }

      });

  }


  function playVisibleVideos(section) {

    if (
      section.dataset.ptgAutoplay !== 'true'
    ) {
      return;
    }


    section
      .querySelectorAll(
        '.ptg-hosted-video'
      )
      .forEach(function (video) {

        const rect =
          video.getBoundingClientRect();

        const viewportHeight =
          window.innerHeight ||
          document.documentElement.clientHeight;

        const visible =
          rect.bottom > 0 &&
          rect.top < viewportHeight;


        if (!visible) {
          return;
        }


        const promise =
          video.play();


        if (
          promise &&
          typeof promise.catch === 'function'
        ) {

          promise.catch(
            function () {}
          );

        }

      });

  }


  function findNavigation(group) {

    return Array.from(
      document.querySelectorAll(
        GENERATED_NAV_SELECTOR
      )
    ).find(function (nav) {

      return (
        nav.dataset.ptgGroup === group
      );

    });

  }


  function activateSection(
    targetId,
    focusButton
  ) {

    const target =
      document.getElementById(targetId);


    if (!target) {
      return;
    }


    const group =
      target.dataset.ptgGroup;


    const sections =
      gallerySections().filter(
        function (section) {

          return (
            section.dataset.ptgGroup === group
          );

        }
      );


    sections.forEach(function (section) {

      const active =
        section.id === targetId;

      const wrapper =
        getWrapper(section);


      section.classList.toggle(
        'ptg-is-active',
        active
      );


      wrapper.classList.toggle(
        'ptg-wrapper-hidden',
        !active
      );


      section.setAttribute(
        'aria-hidden',
        active ? 'false' : 'true'
      );


      if (!active) {

        pauseSectionMedia(section);

      }

    });


    const nav =
      findNavigation(group);


    if (nav) {

      nav.dataset.activeTarget =
        targetId;


      nav
        .querySelectorAll(
          '.ptg-group-nav__button'
        )
        .forEach(function (button) {

          const active =
            button.dataset.ptgTarget ===
            targetId;


          button.classList.toggle(
            'is-active',
            active
          );


          button.setAttribute(
            'aria-selected',
            active ? 'true' : 'false'
          );


          button.setAttribute(
            'tabindex',
            active ? '0' : '-1'
          );

        });


      if (focusButton) {

        const activeButton =
          Array.from(
            nav.querySelectorAll(
              '.ptg-group-nav__button'
            )
          ).find(function (button) {

            return (
              button.dataset.ptgTarget ===
              targetId
            );

          });


        if (activeButton) {

          activeButton.focus();

        }

      }

    }


    window.requestAnimationFrame(
      function () {

        playVisibleVideos(target);

      }
    );

  }


  function createNavigation(
    group,
    sections,
    previousTarget
  ) {

    if (!sections.length) {
      return;
    }


    const first =
      sections[0];


    const nav =
      document.createElement('div');


    nav.className =
      'ptg-group-nav';


    nav.dataset.ptgGenerated =
      'true';


    nav.dataset.ptgGroup =
      group;


    nav.dataset.align =
      first.dataset.ptgTabAlign ||
      'center';


    nav.setAttribute(
      'role',
      'navigation'
    );


    nav.setAttribute(
      'aria-label',
      'Gallery categories'
    );


    copyNavigationStyles(
      first,
      nav
    );


    const inner =
      document.createElement('div');


    inner.className =
      'ptg-group-nav__inner';


    inner.setAttribute(
      'role',
      'tablist'
    );


    sections.forEach(
      function (section, index) {

        const button =
          document.createElement('button');


        const title =
          section.dataset.ptgTitle ||
          (
            'Gallery ' +
            String(index + 1)
          );


        const buttonId =
          'ptg-button-' +
          section.dataset.ptgSectionId;


        button.type =
          'button';


        button.id =
          buttonId;


        button.className =
          'ptg-group-nav__button';


        button.textContent =
          title;


        button.dataset.ptgTarget =
          section.id;


        button.setAttribute(
          'role',
          'tab'
        );


        button.setAttribute(
          'aria-controls',
          section.id
        );


        button.setAttribute(
          'aria-selected',
          'false'
        );


        button.setAttribute(
          'tabindex',
          '-1'
        );


        section.setAttribute(
          'aria-labelledby',
          buttonId
        );


        button.addEventListener(
          'click',
          function () {

            activateSection(
              section.id,
              false
            );

          }
        );


        button.addEventListener(
          'keydown',
          function (event) {

            const buttons =
              Array.from(
                inner.querySelectorAll(
                  '.ptg-group-nav__button'
                )
              );


            const currentIndex =
              buttons.indexOf(button);


            let nextIndex =
              null;


            if (
              event.key === 'ArrowRight'
            ) {

              nextIndex =
                (
                  currentIndex + 1
                ) %
                buttons.length;

            }


            if (
              event.key === 'ArrowLeft'
            ) {

              nextIndex =
                (
                  currentIndex -
                  1 +
                  buttons.length
                ) %
                buttons.length;

            }


            if (
              event.key === 'Home'
            ) {

              nextIndex =
                0;

            }


            if (
              event.key === 'End'
            ) {

              nextIndex =
                buttons.length - 1;

            }


            if (nextIndex !== null) {

              event.preventDefault();


              activateSection(
                buttons[nextIndex]
                  .dataset.ptgTarget,
                true
              );

            }

          }
        );


        inner.appendChild(
          button
        );

      }
    );


    nav.appendChild(
      inner
    );


    const firstWrapper =
      getWrapper(first);


    firstWrapper.parentNode.insertBefore(
      nav,
      firstWrapper
    );


    let initialSection =
      sections.find(
        function (section) {

          return (
            section.id ===
            previousTarget
          );

        }
      );


    if (!initialSection) {

      initialSection =
        first;

    }


    activateSection(
      initialSection.id,
      false
    );

  }


  function buildGalleryGroups() {

    const previousTargets =
      new Map();


    document
      .querySelectorAll(
        GENERATED_NAV_SELECTOR
      )
      .forEach(function (nav) {

        previousTargets.set(
          nav.dataset.ptgGroup,
          nav.dataset.activeTarget
        );


        nav.remove();

      });


    const sections =
      gallerySections();


    const groups =
      new Map();


    sections.forEach(
      function (section) {

        const group =
          section.dataset.ptgGroup;


        if (!groups.has(group)) {

          groups.set(
            group,
            []
          );

        }


        groups
          .get(group)
          .push(section);

      }
    );


    groups.forEach(
      function (
        groupSections,
        group
      ) {

        createNavigation(
          group,
          groupSections,
          previousTargets.get(group)
        );

      }
    );

  }


  let videoObserver =
    null;


  function setupVideoObserver() {

    if (
      !('IntersectionObserver' in window)
    ) {
      return;
    }


    if (!videoObserver) {

      videoObserver =
        new IntersectionObserver(

          function (entries) {

            entries.forEach(
              function (entry) {

                const video =
                  entry.target;


                const section =
                  video.closest(
                    '.ptg-tab-section'
                  );


                if (!section) {
                  return;
                }


                const active =
                  section.classList.contains(
                    'ptg-is-active'
                  );


                const autoplay =
                  section.dataset
                    .ptgAutoplay ===
                  'true';


                if (
                  active &&
                  autoplay &&
                  entry.isIntersecting &&
                  entry.intersectionRatio >=
                    0.35
                ) {

                  const promise =
                    video.play();


                  if (
                    promise &&
                    typeof promise.catch ===
                      'function'
                  ) {

                    promise.catch(
                      function () {}
                    );

                  }

                } else {

                  try {

                    video.pause();

                  } catch (error) {}

                }

              }
            );

          },

          {
            threshold: [
              0,
              0.35,
              0.75
            ]
          }

        );

    }


    document
      .querySelectorAll(
        '.ptg-hosted-video:not([data-ptg-observed])'
      )
      .forEach(function (video) {

        video.dataset.ptgObserved =
          'true';


        videoObserver.observe(
          video
        );

      });

  }


  function initialize() {

    buildGalleryGroups();

    setupVideoObserver();

  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initialize
    );

  } else {

    initialize();

  }


  /*
   * Shopify Theme Editor support
   */

  document.addEventListener(
    'shopify:section:load',
    function () {

      window.setTimeout(
        initialize,
        20
      );

    }
  );


  document.addEventListener(
    'shopify:section:unload',
    function () {

      window.setTimeout(
        initialize,
        20
      );

    }
  );


  document.addEventListener(
    'shopify:section:reorder',
    function () {

      window.setTimeout(
        initialize,
        20
      );

    }
  );


  document.addEventListener(
    'shopify:section:select',
    function (event) {

      if (
        !event.detail ||
        !event.detail.sectionId
      ) {
        return;
      }


      const section =
        findSectionByShopifyId(
          event.detail.sectionId
        );


      if (section) {

        activateSection(
          section.id,
          false
        );

      }

    }
  );


  document.addEventListener(
    'shopify:block:select',
    function (event) {

      const selected =
        event.target.closest
          ? event.target.closest(
              '.ptg-tab-section'
            )
          : null;


      if (selected) {

        activateSection(
          selected.id,
          false
        );

        return;

      }


      if (
        event.detail &&
        event.detail.sectionId
      ) {

        const section =
          findSectionByShopifyId(
            event.detail.sectionId
          );


        if (section) {

          activateSection(
            section.id,
            false
          );

        }

      }

    }
  );

})();


  } catch(e) { console.error(e); }
})();
})();
